import { Affiliate } from '../translations-types';

const translations: Affiliate = {
  userDetails: 'User Details',
  bankDetails: 'Bank Details',
  swiftCode: 'Swift Code',
  iban: 'IBAN',
  bankName: 'Bank Name',
  country: 'Country',
  countryCode: 'Country Code',
  city: 'City',
  postalCode: 'Postal Code',
  streetAddress: 'Street Address',
  recipientFullName: 'Recipient Full Name',
  amount: 'Amount',
  agreeToAffiliates: 'Agree to Affiliates',
  termsAndConditions: 'Terms & Conditions',
  pleaseAgreeToTerms: 'Please agree to terms & conditions',
  resenceReferralProgram: 'Re-sence Referral Program',
  login: 'Login',
  signIn: 'Sign In',
  signOut: 'Sign out',
  forgotPassword: 'Forgot password?',
  commission: 'Commission',
  commissions: 'Commissions',
  status: 'Status',
  confirmed: 'Confirmed',
  completed: 'Completed',
  pending: 'Pending',
  affiliateUser: 'Affiliate User',
  accumulatedCommission: 'Accumulated Commission',
  withdrawTooltip: 'To withdraw you need to fill in you bank details in your Profile.',
  withdraw: 'Withdraw',
  withdrawCommissions: 'Withdraw Commissions',
  withdrawals5Days: 'Withdrawals are usually processed within 5 business days.',
  earnings: 'Earnings',
  faqTitle: 'FAQ about Recommendations and Earnings',
  totalCommission: 'Total Commission',
  totalRecommendations: 'Total Recommendations',
  myWithdrawals: 'My Withdrawals',
  editCode: 'Edit Affiliate Code',
  ifYouChangeLink: 'If you change your link, your old one will no longer work.',
  codeValidation: '6-15 characters. Letters and numbers only.',
  code: 'Code',
  linkCopied: 'Link copied Successfully',
  codeCopied: 'Discount Code copied Successfully',
  inviteTitle: 'Invite beauty specialists, Earn Commission!',
  copyLink: 'Copy Link',
  copyDiscountCode: 'Copy Discount Code',
  referResence: 'Refer Re-sence to your friend',
  profileSettings: 'Profile settings',
  navigationInvite: 'Invite',
  navigationCommissions: 'Commissions',
  navigationEarnings: 'Earnings',
};

export default translations;
